import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';

import Utils from 'src/app/utils';

@Component({
  selector: 'app-worker-last-shift-started',
  templateUrl: './worker-last-shift-started.component.html',
  styleUrls: ['./worker-last-shift-started.component.scss']
})
export class WorkerLastShiftStartedComponent implements OnInit {

  workers: any;

  monitor = '';
  group = '';

  monitors:any = [];
  groups:any = [];

  u = Utils;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.getWorkers();

  }

  getWorkers(){

    if(this.monitor == null){
      this.monitor = '';
    }

    if(this.group == null){
      this.group = '';
    }

    //console.log({monitor:this.monitor,group:this.group});

    this.okService.get('reports/workerlastshift',{monitor:this.monitor,group:this.group})
    .subscribe((data) => {

      this.workers = data.body;
      this.groups = this.okService.groups;
      this.monitors = this.okService.monitors;

      //console.log('getworkers',this.workers);
      // //console.log('getworkers - groups',this.groups);
      // //console.log('getworkers - monitors',this.monitors);

    });
  }

  updateFilter(){
    this.getWorkers();
  }

  clearFilter(){
    this.monitor = '';
    this.group = '';
    this.updateFilter();
  }

  export(){

    if(this.monitor == null){
      this.monitor = '';
    }

    if(this.group == null){
      this.group = '';
    }

    let fields:any = {'export':true};
    fields['monitor'] = this.monitor;
    fields['group'] = this.group;


    this.okService.download("reports/workerlastshift",fields);

  }

}
